import { VERSION } from '../types/constants';

const headers = {
  'X-Brainfish-Widget-Version': VERSION,
};

// NOTE: This function is used to make POST requests to the Brainfish API.
// IT USES `fetch` even though it looks like it's using `ky`.
// This is because `ky` doesn't transpile down well and breaks the widget in iOS 14.4.
// I've kept it as looking like `ky` to prevent from having to refactor the code everywhere else.

type KyPostParams = {
  endpoint: string;
  requestBody: unknown;
  apiKey?: string;
  accessToken?: string;
  returnBody?: boolean;
};

export async function kyPost<T>(
  params: KyPostParams & {
    returnBody: true;
  },
): Promise<ReadableStream<Uint8Array> | null>;

export async function kyPost<T>(
  params: KyPostParams & {
    returnBody?: false;
  },
): Promise<T>;

export async function kyPost<T>({
  endpoint,
  apiKey,
  accessToken,
  requestBody,
  returnBody,
}: KyPostParams): Promise<T | ReadableStream<Uint8Array> | null> {
  const combinedHeaders = {
    ...headers,
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...(apiKey ? { 'api-key': apiKey } : {}),
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: combinedHeaders,
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return returnBody ? response.body : response.json();
}
